module.exports = __webpack_public_path__ + "static/media/flotilla.956d7abe.jpg";